import * as types from '../mutation-types'
import api from '@/api/user'
import router from "@/router";
// import {slugify} from "@/helpers/slugify";

// initial state
const state = {
    loaded: false,
    bookmarks: false,
    companies: [],
    company: {},
    user: {},
    userContentFieldOptions: {},
    settingsGlobal: [],
    settingTypes: [],
    sections: [],
    notifications: [],
    highlightedContent: [],
    settingsCompany: [],
    engagements: [],
    contentFields: [],
    contentFieldOptions: [],
}

const getters = {
    userInfoLoaded: state => state.loaded,
    userInfo: state => state.userInfo,
    user: state => state.user,
    userContentFieldOptions: state => state.userContentFieldOptions,
    company: state => state.company,
    sections: state => state.sections,
    notifications: state => state.notifications,
    highlightedContent: state => state.highlightedContent,
    settingsCompany: state => state.settingsCompany,
    settingsGlobal: state => state.settingsGlobal,
    contentFields: state => state.contentFields,
    contentFieldOptions: state => state.contentFieldOptions,
    bookmarks: state => state.bookmarks,
}

const actions = {
    updateNotification({ commit }, id) {
       commit(types.UPDATE_NOTIFICATION, id );
    },
    getUserInfo({ commit, dispatch }, id) {
        commit(types.SET_USER_INFO_LOADED,  false );
        api.getUserInfo(id, (response) => {
            if(response.userinfo.settingsCompany.length === 1 && response.userinfo.settingsCompany.some(item => item.code === 'AGREEMENTNEEDED')) {
                commit(types.SET_COMPANY,  response.userinfo.company );
                commit(types.SET_SETTINGS_COMPANY,  response.userinfo.settingsCompany );
                router.push('/agreement')
            }
            commit(types.SET_COMPANIES,  response.userinfo.companies );
            commit(types.SET_BOOKMARKS,  response.userinfo.bookmarks );
            commit(types.SET_USER_COMPANIES,  response.userinfo.companies );
            commit(types.SET_COMPANY,  response.userinfo.company );
            commit(types.SET_USER,  response.userinfo.user );
            commit(types.SET_USER_CONTENT_FIELD_OPTIONS,  response.userinfo.userContentFieldOptions );
            commit(types.SET_SETTINGS_GLOBAL,  response.userinfo.settingsGlobal );
            commit(types.SET_SETTINGS_TYPES,  response.userinfo.settingTypes );
            commit(types.SET_SECTIONS,  response.userinfo.sections );
            commit(types.SET_NOTIFICATIONS,  response.userinfo.pendingNotificationContent );
            commit(types.SET_HIGHLIGHTED_CONTENT_ORDER,  response.userinfo.highlightedContent );
            commit(types.SET_SETTINGS_COMPANY,  response.userinfo.settingsCompany );
            commit(types.SET_UI_ENGAGEMENTS,  response.userinfo.engagements );
            commit(types.SET_CONTENT_FIELDS,  response.userinfo.contentFields );
            commit(types.SET_CONTENT_FIELD_OPTIONS,  response.userinfo.contentFieldOptions );
            commit(types.SET_USER_INFO_LOADED,  true );
            dispatch('getHighlightContent');
        })
    },
}

const mutations = {
    [types.SET_USER_INFO_LOADED] (state, status ) {
        state.loaded = status
    },
    [types.SET_BOOKMARKS] (state, data ) {
        state.bookmarks = data
    },
    [types.SET_COMPANIES] (state, data ) {
        state.companies = data
    },
    [types.SET_COMPANY] (state, data ) {
        state.company = data
    },
    [types.SET_USER] (state, data ) {
        state.user = data
        window._paq.push(['setUserId', data.email])
    },
    [types.SET_SETTINGS_GLOBAL] (state, data ) {
        state.settingsGlobal = data
    },
    [types.SET_SETTINGS_TYPES] (state, data ) {
        state.settingTypes = data
    },
    [types.SET_SECTIONS] (state, data ) {
        state.sections = data
    },
    [types.SET_USER_CONTENT_FIELD_OPTIONS] (state, data ) {
        state.userContentFieldOptions = data
    },
    [types.SET_NOTIFICATIONS] (state, data ) {
        state.notifications = data
    },
    [types.SET_HIGHLIGHTED_CONTENT_ORDER] (state, data ) {
        state.highlightedContent = data
    },
    [types.SET_SETTINGS_COMPANY] (state, data ) {
        state.settingsCompany = data
    },
    [types.SET_UI_ENGAGEMENTS] (state, data ) {
        state.engagements = data
    },
    [types.SET_CONTENT_FIELDS] (state, data ) {
        state.contentFields = data
    },
    [types.SET_CONTENT_FIELD_OPTIONS] (state, data ) {
        state.contentFieldOptions = data
    },
    [types.UPDATE_NOTIFICATION] (state, id ) {
        state.sections.forEach(item => {
            if (item.idSettingCompany === id) {
                item.readPending = null
            }
        })

    }
}


export default {
    state,
    getters,
    actions,
    mutations
}
